import customAxios from "../../customAxios";
import { GET_ACADEMIC_YEARS } from "../../routes";

// ? Returns { docs: IAcademicYear[], current: IAcademicYear | null }.
// ? Open to every authenticated role, not just ADMIN, because every panel needs the selector.
const getAllAcademicYear = async () => {
  try {
    return (await customAxios.get(GET_ACADEMIC_YEARS)).data;
  } catch (error: any) {
    console.log({ GET_ACADEMIC_YEARS: error });
  }
};

export default getAllAcademicYear;
